<template>
  <div>
    <div class="confirm card" id="confirm-modal">
      <div class="confirm-header"><h4 class="title">{{ $t('fields.confirmar') }}</h4></div>
      <div class="confirm-body"></div>
      <div class="confirm-footer">
        <button class="btn" @click="close">{{ $t('fields.cancelar') }}</button>
        <button class="btn btn-primary" @click="ok">{{ $t('fields.aceptar') }}</button>
      </div>
    </div><div class="confirm-shadow"></div>
  </div>
</template>

<script>
export default {
  methods: {
    close () {
      let confirm = document.getElementById('confirm-modal');
      confirm.querySelector('.confirm-body').innerHTML = '';
      confirm.style.display = 'none';
      confirm.nextSibling.style.display = 'none';
    },
    cancel () {
      if (typeof this.$store.state.cancel === 'function') {
        this.$store.state.cancel();
        this.$store.commit('setCancel', null);
      }
      this.close();
    },
    ok () {
      if (typeof this.$store.state.ok === 'function') {
        this.$store.state.ok();
        this.$store.commit('setOk', null);
      }
      this.close();
    }
  }
};
</script>

<style lang="scss">
.confirm {
  position: fixed;
  top: 50%;
  left: 50%;
  background-color: white;
  padding: 20px;
  transform: translate(-50%, -50%);
  z-index: 10;
  min-width: 400px;
  display: none;

  .confirm-footer {
    text-align: right;
    padding-top: 20px;
  }
}
.confirm-shadow {
  position: fixed;
  background-color: rgba(0, 0, 0, .5);
  z-index: 9;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: none;
}
@media (max-width: 768px) {
  .confirm {
    min-width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/util/Confirm.vue